module.exports = __webpack_public_path__ + "img/clue3_light.30baa3f5.png";